"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var WishlistIcon = function WishlistIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    strokeLinejoin: "round",
    clipRule: "evenodd",
    d: "M11.847 21C12.911 20.567 22.6 16.43 22.6 9.487c0-7.345-6.346-6.453-6.346-6.453S13.166 3.367 11.8 5.9c-1.366-2.533-4.454-2.866-4.454-2.866S1 2.142 1 9.487C1 16.43 10.69 20.567 11.753 21h.094z"
  }));
};
WishlistIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#fff"
};
var WishlistPlaceholder = function WishlistPlaceholder() {
  return /*#__PURE__*/_react["default"].createElement(StyledWishlistPlaceholder, null, /*#__PURE__*/_react["default"].createElement("p", null, "\u0417\u0434\u0435\u0441\u044C \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0435 \u0441\u0441\u044B\u043B\u043A\u0438 \u043D\u0430 \u0442\u0443\u0440\u044B \u0438\u043B\u0438 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u043D\u044B\u0435 \u043F\u043E\u0438\u0441\u043A\u0438."), /*#__PURE__*/_react["default"].createElement("p", null, "\u0422\u0430\u043A\u0436\u0435 \u0432\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0441\u0432\u043E\u0438\u043C\u0438 \u043D\u0430\u0445\u043E\u0434\u043A\u0430\u043C\u0438 \u0441 \u0434\u0440\u0443\u0437\u044C\u044F\u043C\u0438 \u0438\u043B\u0438 \u0437\u043D\u0430\u043A\u043E\u043C\u044B\u043C\u0438 \u0438 \u0441\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0441\u0432\u043E\u0439 \u043E\u0442\u0434\u044B\u0445 \u0435\u0449\u0435 \u043B\u0443\u0447\u0448\u0435 :)"), /*#__PURE__*/_react["default"].createElement("p", null, "\u0418\u0449\u0438\u0442\u0435 \u0438\u043A\u043E\u043D\u043A\u0443 ", /*#__PURE__*/_react["default"].createElement(Heart, null), " \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0447\u0442\u043E\u0431\u044B \u043F\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u044C \u0441\u0432\u043E\u0439 \u0441\u043F\u0438\u0441\u043E\u043A."));
};
var StyledWishlistPlaceholder = _styledComponents["default"].div.withConfig({
  displayName: "WishlistPlaceholder__StyledWishlistPlaceholder",
  componentId: "sc-1fq0ng4-0"
})(["border:2px dashed #2929294d;padding:10px;margin:0 10px 10px 10px;background-color:#fff;text-align:center;p + p{margin-top:15px;}"]);
var Heart = (0, _styledComponents["default"])(WishlistIcon).attrs({
  wisth: 16,
  height: 14,
  stroke: '#000'
}).withConfig({
  displayName: "WishlistPlaceholder__Heart",
  componentId: "sc-1fq0ng4-1"
})(["vertical-align:bottom;"]);
var _default = exports["default"] = WishlistPlaceholder;